import styled, { css } from 'styled-components';

import type { ComplianceOcrStatus } from '../../../types/api';
import { getComplianceOcrStatusLabel } from '../lib/labels';

const Badge = styled.span<{ $status: ComplianceOcrStatus | null }>`
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: none;
  letter-spacing: 0.04em;
  line-height: 1;
  white-space: nowrap;

  ${({ $status }) => {
    switch ($status) {
      case 'pending':
        return css`
          background: var(--info-100);
          color: var(--info-600);
        `;
      case 'succeeded':
        return css`
          background: var(--success-100);
          color: var(--success-600);
        `;
      case 'failed':
        return css`
          background: var(--danger-100);
          color: var(--danger-600);
        `;
      default:
        return css`
          background: var(--neutral-100);
          color: var(--text-muted);
        `;
    }
  }}
`;

interface ComplianceOcrStatusBadgeProps {
  status: ComplianceOcrStatus | null;
  className?: string;
}

export const ComplianceOcrStatusBadge = ({
  status,
  className,
}: ComplianceOcrStatusBadgeProps) => {
  return (
    <Badge className={className} $status={status}>
      {getComplianceOcrStatusLabel(status)}
    </Badge>
  );
};

ComplianceOcrStatusBadge.displayName = 'ComplianceOcrStatusBadge';
